// ContactUs.js - Fixed template parameters (no to_email)
import Momentsia_logo from "../images/Momentsia _logo.png";
import React, { useEffect, useState } from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer"; // <-- ADD THIS IMPORT
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import SendIcon from "@mui/icons-material/Send";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import emailjs from '@emailjs/browser';

const T1 = "#0ecfb0";
const T2 = "#0aa896";
const T3 = "#077a6e";
const NAVY = "#0d1b2a";
const NAVY2 = "#112233";
const DARK = "#1a1a1a";
const TEAL_GRAD = `linear-gradient(135deg, ${T1}, ${T3})`;

// EmailJS Configuration
const EMAILJS_SERVICE_ID = "service_zieecow";      
const EMAILJS_TEMPLATE_ID = "template_l1xmaal";     
const EMAILJS_PUBLIC_KEY = "q2O06yijgnOJTch1m"; 

const eventTypes = [
  "Corporate Event",
  "Wedding",
  "Birthday Party",
  "Conference",
  "Product Launch",
  "Music Concert",
  "Other",
];

const MomentsiaLogo = ({ light = false }) => (
  <div style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
    <img src={Momentsia_logo} alt="Momentsia" style={{ height: 48, width: "auto", objectFit: "contain" }} />
  </div>
);

// Consult Dialog
const ConsultDialog = ({ open, onClose }) => {
  const [dialogFormData, setDialogFormData] = useState({ 
    name: "", phone: "", email: "", eventType: "", date: "", guests: "", message: "" 
  });
  const [dialogErrors, setDialogErrors] = useState({});
  const [dialogStatus, setDialogStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateDialogForm = () => {
    const newErrors = {};
    if (!dialogFormData.name?.trim()) newErrors.name = "Name is required";
    if (!dialogFormData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(dialogFormData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!dialogFormData.phone?.trim()) newErrors.phone = "Phone number is required";
    if (!dialogFormData.eventType) newErrors.eventType = "Event type is required";
    if (!dialogFormData.date) newErrors.date = "Date is required";
    setDialogErrors(newErrors);
    return newErrors;
  };

  const handleDialogChange = (e) => {
    const { name, value } = e.target;
    setDialogFormData({ ...dialogFormData, [name]: value });
    if (dialogErrors[name]) {
      setDialogErrors({ ...dialogErrors, [name]: "" });
    }
  };

  const handleDialogSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateDialogForm();
    if (Object.keys(validationErrors).length > 0) return;
    
    setIsSubmitting(true);
    setDialogStatus("Sending...");

    const templateParams = {
      from_name: dialogFormData.name.trim(),
      from_email: dialogFormData.email.trim(),
      from_phone: dialogFormData.phone?.trim() || "Not provided",
      event_type: dialogFormData.eventType,
      event_date: dialogFormData.date,
      guests: dialogFormData.guests?.toString().trim() || "Not specified",
      message: dialogFormData.message?.trim() || "No additional message provided",
      submitted_at: new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    try {
      const response = await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_TEMPLATE_ID,
        templateParams,
        EMAILJS_PUBLIC_KEY
      );
      
      console.log("Dialog - Email sent successfully!", response);
      setDialogStatus("✓ Request sent successfully! We'll contact you within 24 hours.");
      setDialogFormData({ name: "", phone: "", email: "", eventType: "", date: "", guests: "", message: "" });
      setDialogErrors({});
      
      setTimeout(() => {
        setDialogStatus("");
        onClose();
      }, 2000);
    } catch (error) {
      console.error("Dialog - Failed to send email:", error);
      setDialogStatus("❌ Failed to send. Please try again or call us directly.");
      setTimeout(() => setDialogStatus(""), 3000);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!open) return null;
  
  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div onClick={onClose} style={{ position: "absolute", inset: 0, background: "rgba(0,0,0,0.6)" }} />
      <div style={{ position: "relative", background: "#fff", borderRadius: 14, padding: "40px 36px", maxWidth: 520, width: "90%", boxShadow: "0 24px 64px rgba(0,0,0,0.25)", maxHeight: "90vh", overflowY: "auto" }}>
        <button onClick={onClose} style={{ position: "absolute", top: 14, right: 18, background: "none", border: "none", fontSize: 22, cursor: "pointer", color: "#aaa" }}>✕</button>
        <div style={{ height: 4, background: TEAL_GRAD, borderRadius: 4, marginBottom: 24 }} />
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
          <img src={Momentsia_logo} alt="Momentsia" style={{ height: 32, width: "auto" }} />
          <h3 style={{ margin: 0, color: DARK, fontWeight: 800, fontSize: 20 }}>Plan Your Perfect Event</h3>
        </div>
        <p style={{ color: "#888", fontSize: 13, margin: "0 0 22px" }}>Share your event details – we'll create a customized proposal within 24 hours.</p>
        
        <form onSubmit={handleDialogSubmit}>
          <input type="text" name="name" placeholder="Full Name *" value={dialogFormData.name} onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.name ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14, boxSizing: "border-box" }} />
          {dialogErrors.name && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.name}</p>}
          
          <input type="tel" name="phone" placeholder="Phone Number *" value={dialogFormData.phone} onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.phone ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14, boxSizing: "border-box" }} />
          {dialogErrors.phone && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.phone}</p>}
          
          <input type="email" name="email" placeholder="Email Address *" value={dialogFormData.email} onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.email ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14, boxSizing: "border-box" }} />
          {dialogErrors.email && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.email}</p>}
          
          <select name="eventType" value={dialogFormData.eventType} onChange={handleDialogChange} required
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.eventType ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14, background: "#fff" }}>
            <option value="">Select Event Type *</option>
            {eventTypes.map(type => <option key={type} value={type}>{type}</option>)}
          </select>
          {dialogErrors.eventType && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.eventType}</p>}
          
          <input type="date" name="date" value={dialogFormData.date} onChange={handleDialogChange} required
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: `1.5px solid ${dialogErrors.date ? "#f44336" : "#e0e0e0"}`, borderRadius: 7, fontSize: 14 }} />
          {dialogErrors.date && <p style={{ color: "#f44336", fontSize: 11, margin: "-8px 0 12px 0" }}>{dialogErrors.date}</p>}
          
          <input type="number" name="guests" placeholder="Approximate Guests" value={dialogFormData.guests} onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 13, padding: "11px 14px", border: "1.5px solid #e0e0e0", borderRadius: 7, fontSize: 14 }} />
          
          <textarea name="message" placeholder="Tell us about your event..." rows={3} value={dialogFormData.message} onChange={handleDialogChange}
            style={{ display: "block", width: "100%", marginBottom: 18, padding: "11px 14px", border: "1.5px solid #e0e0e0", borderRadius: 7, fontSize: 14, resize: "vertical" }} />
          
          <button type="submit" disabled={isSubmitting}
            style={{ width: "100%", padding: "13px 0", background: TEAL_GRAD, color: "#fff", border: "none", borderRadius: 7, fontWeight: 700, fontSize: 15, cursor: isSubmitting ? "not-allowed" : "pointer", opacity: isSubmitting ? 0.7 : 1 }}>
            {isSubmitting ? "Submitting..." : "Submit Inquiry"}
          </button>
          {dialogStatus && <p style={{ marginTop: 16, fontSize: 12, textAlign: "center", color: dialogStatus.includes("✓") ? T2 : T1 }}>{dialogStatus}</p>}
        </form>
      </div>
    </div>
  );
};

// FAQ Accordion Item
const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ borderBottom: "1px solid #e0e0e0", padding: "12px 0" }}>
      <button onClick={() => setOpen(!open)} style={{ width: "100%", background: "none", border: "none", display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", padding: "8px 0", fontSize: 16, fontWeight: 600, color: DARK }}>
        {question}
        {open ? <ExpandLessIcon sx={{ color: T1 }} /> : <ExpandMoreIcon sx={{ color: T1 }} />}
      </button>
      {open && <p style={{ margin: "8px 0 0", color: "#555", fontSize: 14, lineHeight: 1.5, paddingRight: 16 }}>{answer}</p>}
    </div>
  );
};

export default function ContactUs() {
  const [openForm, setOpenForm] = useState(false);
  
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", eventType: "", date: "", guests: "", message: "" });
  const [errors, setErrors] = useState({});
  const [formStatus, setFormStatus] = useState("");
  const [isSubmittingForm, setIsSubmittingForm] = useState(false);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name?.trim()) newErrors.name = "Name is required";
    if (!formData.email?.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Email is invalid";
    }
    if (!formData.phone?.trim()) newErrors.phone = "Phone number is required";
    if (!formData.eventType) newErrors.eventType = "Event type is required";
    if (!formData.date) newErrors.date = "Date is required";
    setErrors(newErrors);
    return newErrors;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    if (errors[name]) setErrors({ ...errors, [name]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) return;
    
    setIsSubmittingForm(true);
    setFormStatus("Sending...");

    const templateParams = {
      from_name: formData.name.trim(),
      from_email: formData.email.trim(),
      from_phone: formData.phone?.trim() || "Not provided",
      event_type: formData.eventType,
      event_date: formData.date,
      guests: formData.guests?.toString().trim() || "Not specified",
      message: formData.message?.trim() || "No additional message provided",
      submitted_at: new Date().toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }),
    };

    try {
      await emailjs.send(EMAILJS_SERVICE_ID, EMAILJS_TEMPLATE_ID, templateParams, EMAILJS_PUBLIC_KEY);
      setFormStatus("✓ Thank you! We'll contact you within 24 hours.");
      setFormData({ name: "", email: "", phone: "", eventType: "", date: "", guests: "", message: "" });
      setErrors({});
      setTimeout(() => setFormStatus(""), 4000);
    } catch (error) {
      console.error("Failed to send:", error);
      setFormStatus("❌ Failed to send. Please try again or call us directly.");
      setTimeout(() => setFormStatus(""), 4000);
    } finally {
      setIsSubmittingForm(false);
    }
  };

  return (
    <div style={{ fontFamily: "'Segoe UI', Arial, sans-serif", margin: 0, padding: 0, color: DARK }}>
      <link href="https://fonts.googleapis.com/css2?family=Allura&display=swap" rel="stylesheet" />
      <style>{`
        *{box-sizing:border-box;}body{margin:0;}
        h1, h2 { font-family: 'Allura', cursive !important; letter-spacing: 1px; }
        .contact-card, .info-card { transition: transform 0.3s, box-shadow 0.3s; }
        .contact-card:hover, .info-card:hover { transform: translateY(-6px); box-shadow: 0 20px 30px rgba(14,207,176,0.15) !important; }
        .cb:hover{opacity:0.88;transform:translateY(-1px);}
        input:focus, textarea:focus, select:focus { border-color: ${T1} !important; outline: none; box-shadow: 0 0 0 2px rgba(14,207,176,0.2); }
      `}</style>

      {/* Navigation Component */}
      <Navigation onPlanEventClick={() => setOpenForm(true)} />

      {/* Hero Section */}
      <div style={{ position: "relative", width: "100%", background: "#000" }}>
        <div style={{ position: "relative", width: "100%", height: "45vh", minHeight: 320, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <img src="https://images.unsplash.com/photo-1423666639041-f56000c27a1a?w=1920&h=600&fit=crop" alt="Contact Momentsia"
            style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 1 }} />
          <div style={{ position: "absolute", inset: 0, background: `linear-gradient(135deg,rgba(7,122,110,0.7) 0%,rgba(0,0,0,0.6) 100%)`, zIndex: 2 }} />
          <div style={{ position: "relative", zIndex: 3, textAlign: "center", width: "90%", maxWidth: 800, margin: "0 auto" }}>
            <div style={{ width: 60, height: 3.5, background: TEAL_GRAD, borderRadius: 2, margin: "0 auto 18px" }} />
            <h1 style={{ color: "#fff", fontSize: "clamp(2rem,5vw,3.5rem)", fontWeight: 800, textShadow: "0 2px 20px rgba(0,0,0,0.5)", margin: "0 0 14px" }}>
              Let's Talk
            </h1>
            <p style={{ color: "rgba(255,255,255,0.92)", fontSize: "clamp(1rem,2vw,1.2rem)", margin: 0 }}>
              We're here to answer your questions and bring your vision to life.
            </p>
          </div>
        </div>
      </div>

      {/* Contact Cards */}
      <div style={{ maxWidth: 1100, margin: "-40px auto 60px", padding: "0 24px", position: "relative", zIndex: 5 }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 30 }}>
          <div className="info-card" style={{ background: "#fff", borderRadius: 20, padding: "32px 24px", textAlign: "center", boxShadow: "0 12px 30px rgba(0,0,0,0.08)", borderBottom: `3px solid ${T1}` }}>
            <div style={{ background: `linear-gradient(135deg, ${T1}15, ${T3}15)`, width: 70, height: 70, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
              <PhoneIcon sx={{ fontSize: 36, color: T1 }} />
            </div>
            <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 12, color: DARK }}>Call Us</h3>
            <p style={{ color: T1, fontSize: 20, fontWeight: 700, marginBottom: 8 }}>+91 81003 64941</p>
            <p style={{ color: "#555", fontSize: 14, marginBottom: 6 }}>+91 81003 64941 (Emergency)</p>
          </div>

          <div className="info-card" style={{ background: "#fff", borderRadius: 20, padding: "32px 24px", textAlign: "center", boxShadow: "0 12px 30px rgba(0,0,0,0.08)", borderBottom: `3px solid ${T1}` }}>
            <div style={{ background: `linear-gradient(135deg, ${T1}15, ${T3}15)`, width: 70, height: 70, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
              <EmailIcon sx={{ fontSize: 36, color: T1 }} />
            </div>
            <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 12, color: DARK }}>Email Us</h3>
            <p style={{ color: "#555", fontSize: 15, marginBottom: 6 }}>info@momentsia.com</p>
          </div>

          <div className="info-card" style={{ background: "#fff", borderRadius: 20, padding: "32px 24px", textAlign: "center", boxShadow: "0 12px 30px rgba(0,0,0,0.08)", borderBottom: `3px solid ${T1}` }}>
            <div style={{ background: `linear-gradient(135deg, ${T1}15, ${T3}15)`, width: 70, height: 70, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
              <LocationOnIcon sx={{ fontSize: 36, color: T1 }} />
            </div>
            <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 12, color: DARK }}>Visit Our Office</h3>
            <p style={{ color: "#555", fontSize: 14, lineHeight: 1.5, marginBottom: 8 }}>
              Momentsia P S Abacus - 703<br />
              7th Floor, NH12, Action Area IIE<br />
              Newtown, Kolkata - 700161
            </p>
          </div>
        </div>
      </div>

      {/* Main Two-Column Section: Form + Map/Info */}
      <section style={{ padding: "0 24px 80px" }}>
        <div style={{ maxWidth: 1200, margin: "0 auto", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(380px, 1fr))", gap: 48 }}>
          <div className="contact-card" style={{ background: "#fff", borderRadius: 24, padding: "32px 28px", boxShadow: "0 12px 32px rgba(0,0,0,0.06)", border: `1px solid ${T1}20` }}>
            <h2 style={{ fontSize: 26, fontWeight: 800, color: DARK, marginBottom: 6 }}>Plan Your Perfect Event</h2>
            <div style={{ width: 50, height: 3, background: TEAL_GRAD, borderRadius: 2, marginBottom: 22 }} />
            <p style={{ color: "#666", fontSize: 14, marginBottom: 24 }}>Share your event details with us, and we'll create a customized proposal within 24 hours</p>
            
            <form onSubmit={handleSubmit}>
              <input type="text" name="name" placeholder="Your Name *" value={formData.name} onChange={handleChange} required
                style={{ width: "100%", padding: "14px 16px", marginBottom: 16, border: `1.5px solid ${errors.name ? "#f44336" : "#e0e0e0"}`, borderRadius: 10, fontSize: 14 }} />
              {errors.name && <p style={{ color: "#f44336", fontSize: 12, margin: "-12px 0 16px 0" }}>{errors.name}</p>}
              
              <input type="email" name="email" placeholder="Email Address *" value={formData.email} onChange={handleChange} required
                style={{ width: "100%", padding: "14px 16px", marginBottom: 16, border: `1.5px solid ${errors.email ? "#f44336" : "#e0e0e0"}`, borderRadius: 10, fontSize: 14 }} />
              {errors.email && <p style={{ color: "#f44336", fontSize: 12, margin: "-12px 0 16px 0" }}>{errors.email}</p>}
              
              <input type="tel" name="phone" placeholder="Phone Number *" value={formData.phone} onChange={handleChange} required
                style={{ width: "100%", padding: "14px 16px", marginBottom: 16, border: `1.5px solid ${errors.phone ? "#f44336" : "#e0e0e0"}`, borderRadius: 10, fontSize: 14 }} />
              {errors.phone && <p style={{ color: "#f44336", fontSize: 12, margin: "-12px 0 16px 0" }}>{errors.phone}</p>}
              
              <select name="eventType" value={formData.eventType} onChange={handleChange} required
                style={{ width: "100%", padding: "14px 16px", marginBottom: 16, border: `1.5px solid ${errors.eventType ? "#f44336" : "#e0e0e0"}`, borderRadius: 10, fontSize: 14, background: "#fff" }}>
                <option value="">Select Event Type *</option>
                {eventTypes.map(type => <option key={type} value={type}>{type}</option>)}
              </select>
              {errors.eventType && <p style={{ color: "#f44336", fontSize: 12, margin: "-12px 0 16px 0" }}>{errors.eventType}</p>}
              
              <input type="date" name="date" value={formData.date} onChange={handleChange} required
                style={{ width: "100%", padding: "14px 16px", marginBottom: 16, border: `1.5px solid ${errors.date ? "#f44336" : "#e0e0e0"}`, borderRadius: 10, fontSize: 14 }} />
              {errors.date && <p style={{ color: "#f44336", fontSize: 12, margin: "-12px 0 16px 0" }}>{errors.date}</p>}
              
              <input type="number" name="guests" placeholder="Approximate Guests" value={formData.guests} onChange={handleChange}
                style={{ width: "100%", padding: "14px 16px", marginBottom: 16, border: "1.5px solid #e0e0e0", borderRadius: 10, fontSize: 14 }} />
              
              <textarea name="message" placeholder="Tell us about your event..." rows={4} value={formData.message} onChange={handleChange}
                style={{ width: "100%", padding: "14px 16px", marginBottom: 20, border: "1.5px solid #e0e0e0", borderRadius: 10, fontSize: 14, resize: "vertical" }} />
              
              <button type="submit" disabled={isSubmittingForm}
                style={{ background: TEAL_GRAD, color: "#fff", border: "none", padding: "14px 24px", borderRadius: 40, fontWeight: 700, fontSize: 15, cursor: isSubmittingForm ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, width: "100%", opacity: isSubmittingForm ? 0.7 : 1 }}>
                <SendIcon sx={{ fontSize: 18 }} /> {isSubmittingForm ? "Submitting..." : "Submit Inquiry"}
              </button>
              {formStatus && <p style={{ marginTop: 16, fontSize: 13, color: formStatus.includes("✓") ? T2 : T1, textAlign: "center" }}>{formStatus}</p>}
            </form>
          </div>

          <div>
            <div style={{ borderRadius: 24, overflow: "hidden", boxShadow: "0 8px 20px rgba(0,0,0,0.1)", marginBottom: 28 }}>
              <iframe title="Momentsia Office Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.485862203921!2d88.4589333!3d22.6191563!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39f89f824c69a885%3A0x163982e2b2768dee!2sDecodia%20Design%20Studio!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin" width="100%" height="280" style={{ border: 0 }} allowFullScreen loading="lazy" />
            </div>
            <div style={{ background: "#f8fbfa", borderRadius: 20, padding: "24px 28px", border: `1px solid ${T1}20` }}>
              <h3 style={{ fontSize: 20, fontWeight: 800, marginBottom: 16 }}>Why Choose Elevate Events?</h3>
              {[
                { title: "Personalized Planning", desc: "Customized solutions tailored to your vision and budget" },
                { title: "Expert Team", desc: "Experienced professionals across all event aspects" },
                { title: "Vendor Network", desc: "Access to trusted partners and premium suppliers" },
                { title: "Stress-Free Experience", desc: "We handle all logistics so you can enjoy your event" },
              ].map((item, index) => (
                <div key={index} style={{ display: "flex", marginBottom: 20 }}>
                  <div style={{ minWidth: 36, height: 36, borderRadius: "50%", background: `${T1}10`, display: "flex", alignItems: "center", justifyContent: "center", marginRight: 14, color: T1, fontWeight: 600 }}>{index + 1}</div>
                  <div><p style={{ fontWeight: 700, marginBottom: 4, fontSize: 15 }}>{item.title}</p><p style={{ color: "#666", fontSize: 13, margin: 0 }}>{item.desc}</p></div>
                </div>
              ))}
              <div style={{ marginTop: 20, paddingTop: 16, borderTop: `1px solid ${T1}20` }}>
                <p style={{ fontSize: 13, color: "#666", marginBottom: 8 }}><strong>📍 Office Hours:</strong> 24/7 Support Available</p>
                <p style={{ fontSize: 13, color: "#666", margin: 0 }}><strong>📞 Need immediate assistance?</strong> Call us at <strong style={{ color: T1 }}>+91 81003 64941</strong></p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ background: "#fafafa", padding: "70px 24px" }}>
        <div style={{ maxWidth: 900, margin: "0 auto", textAlign: "center" }}>
          <h2 style={{ fontSize: "clamp(1.8rem,4vw,2.4rem)", fontWeight: 800, color: DARK, marginBottom: 8 }}>Frequently Asked Questions</h2>
          <div style={{ width: 60, height: 3, background: TEAL_GRAD, margin: "0 auto 32px" }} />
          <div style={{ textAlign: "left", background: "#fff", borderRadius: 24, padding: "24px 28px", boxShadow: "0 4px 16px rgba(0,0,0,0.05)" }}>
            <FAQItem question="How do I book an event with Momentsia?" answer="Simply fill out the contact form, call us, or click 'Plan Your Event'. We'll get back within 24 hours with a personalized consultation." />
            <FAQItem question="What types of events do you manage?" answer="Weddings, corporate galas, private parties, product launches, festivals, and more. We tailor every experience." />
            <FAQItem question="Can I hire individual talent (DJ, photographer, etc.)?" answer="Absolutely! Our talent management covers solo artists, emcees, photographers, musicians, and full entertainment crews." />
            <FAQItem question="Do you handle events outside Kolkata?" answer="Yes, we serve pan-India and international destinations. Travel arrangements can be included." />
            <FAQItem question="What is your cancellation policy?" answer="Cancellation terms depend on the event type and advance notice. We'll share clear terms during the booking process." />
          </div>
        </div>
      </section>

      <section style={{ background: `linear-gradient(115deg, ${NAVY} 0%, ${NAVY2} 100%)`, padding: "56px 24px", textAlign: "center" }}>
        <div style={{ maxWidth: 700, margin: "0 auto" }}>
          <h2 style={{ color: "#fff", fontSize: "clamp(1.4rem,3vw,1.8rem)", fontWeight: 800, marginBottom: 12 }}>Ready to start planning?</h2>
          <p style={{ color: "rgba(255,255,255,0.8)", fontSize: 15, marginBottom: 24 }}>Get a free consultation from our event experts.</p>
          <button onClick={() => setOpenForm(true)} style={{ background: T1, color: "#fff", padding: "12px 32px", borderRadius: 40, border: "none", fontWeight: 700, fontSize: 15, cursor: "pointer" }}>Plan Your Event →</button>
        </div>
      </section>

      {/* FOOTER - Now using the imported Footer component */}
      <Footer />

      {/* WhatsApp float */}
      <a href="https://wa.me/918100364941" target="_blank" rel="noreferrer" style={{ position: "fixed", bottom: 24, right: 24, width: 58, height: 58, borderRadius: "50%", background: "#25d366", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 6px 20px rgba(37,211,102,0.4)", zIndex: 9998, textDecoration: "none", fontSize: 28 }}>💬</a>

      <ConsultDialog open={openForm} onClose={() => setOpenForm(false)} />
    </div>
  );
}